import React, { useState, useRef, useEffect } from 'react';
import './PartnerList.scss';

interface Partner {
  _id: string;
  businessName: string;
  image?: string;
}

interface PartnerListProps {
  partners: Partner[];
  isLoading?: boolean;
}

const PartnerList: React.FC<PartnerListProps> = ({ partners, isLoading = false }) => {
  const fileUrl = process.env.REACT_APP_FILE_URL;
  const [isScrolling, setIsScrolling] = useState(false);
  const scrollTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const handleScroll = () => {
    setIsScrolling(true);
    
    if (scrollTimeoutRef.current) {
      clearTimeout(scrollTimeoutRef.current);
    }
    
    scrollTimeoutRef.current = setTimeout(() => {
      setIsScrolling(false);
    }, 1000);
  };

  useEffect(() => {
    return () => {
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
    };
  }, []);
  
  if (isLoading) {
    return (
      <div className="partners-section">
        <div className="partners-header">
          <h6>🏢 Key Partners</h6>
        </div>
        <div 
          className={`partners-scroll-container ${isScrolling ? 'is-scrolling' : ''}`}
          onScroll={handleScroll}
        >
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="partner-card skeleton">
              <div className="skeleton-logo"></div>
              <div className="skeleton-text"></div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (!partners || partners.length === 0) {
    return (
      <div className="partners-section">
        <div className="partners-header">
          <h6>🏢 Key Partners</h6>
        </div>
        <div className="partners-empty">
          <p>No partners assigned to this plan</p>
        </div>
      </div>
    );
  }

  return (
    <div className="partners-section">
      <div className="partners-header">
        <h6>🏢 Key Partners</h6>
      </div>
      <div 
        className={`partners-scroll-container ${isScrolling ? 'is-scrolling' : ''}`}
        onScroll={handleScroll}
      >
        {partners.map((partner) => (
          <div key={partner._id} className="partner-card">
            {partner.image ? (
              <img
                src={fileUrl + partner.image}
                alt={partner.businessName}
                onError={(e) => {
                  // Hide image on error and show placeholder
                  (e.target as HTMLImageElement).style.display = 'none';
                  const placeholder = (e.target as HTMLImageElement).nextElementSibling as HTMLElement;
                  if (placeholder && placeholder.classList.contains('partner-placeholder-hidden')) {
                    placeholder.style.display = 'flex';
                  }
                }}
              />
            ) : null}
            <div className={`partner-placeholder ${partner.image ? 'partner-placeholder-hidden' : ''}`}>
              🏢
            </div>
            <span className="partner-name">{partner.businessName}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PartnerList;

